<template>
    <div class="unidades" id="localizacao">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center unidades__header wow animate__animated animate__fadeInUp">
                    <div class="unidades__label">
                        <span class="unidades__label-line"></span>
                        <span class="unidades__label-text">Unidades</span>
                        <span class="unidades__label-line"></span>
                    </div>
                    <h2 class="unidades__title">
                        Nossos<br>
                        <em>endereços</em>
                    </h2>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 col-lg-6 mb-4 mb-lg-0 wow animate__animated animate__fadeInLeft">
                    <div class="unidades__card">
                        <div class="unidades__card-header">
                            <div class="unidades__card-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                            </div>
                            <div>
                                <h3 class="unidades__card-title">Barueri</h3>
                                <span class="unidades__card-badge">Bethaville I</span>
                            </div>
                        </div>
                        <p class="unidades__card-address">
                            Av. Trindade, 254 - Sala 113<br>
                            Bethaville I - Barueri/SP
                        </p>
                        <div class="unidades__card-map">
                            <iframe
                                src="https://maps.google.com/maps?q=Av%20Trindade%20254%20Bethaville%20Barueri&t=&z=16&ie=UTF8&iwloc=&output=embed"
                                width="100%"
                                height="280"
                                frameborder="0"
                                style="border: 0"
                                allowfullscreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 wow animate__animated animate__fadeInRight">
                    <div class="unidades__card">
                        <div class="unidades__card-header">
                            <div class="unidades__card-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                            </div>
                            <div>
                                <h3 class="unidades__card-title">Itapevi</h3>
                                <span class="unidades__card-badge">Jardim Rosemary</span>
                            </div>
                        </div>
                        <p class="unidades__card-address">
                            Rua Licínio Avelino da Costa, 119<br>
                            Jardim Rosemary - Itapevi/SP<br>
                            CEP: 06404-326
                        </p>
                        <div class="unidades__card-map">
                            <iframe
                                src="https://maps.google.com/maps?q=Rua%20Licinio%20Avelino%20da%20Costa%20119%20Itapevi&t=&z=16&ie=UTF8&iwloc=&output=embed"
                                width="100%"
                                height="280"
                                frameborder="0"
                                style="border: 0"
                                allowfullscreen
                                loading="lazy"
                            ></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.unidades {
    padding: 120px 0;
    background-color: $creme;
    overflow: hidden;

    &__header {
        margin-bottom: 20px;
    }

    &__label {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        margin-bottom: 24px;

        &-line {
            display: block;
            width: 40px;
            height: 1px;
            background-color: $caramelo;
        }

        &-text {
            font-family: $font-body;
            font-weight: 500;
            font-size: 12px;
            letter-spacing: 3px;
            text-transform: uppercase;
            color: $caramelo;
        }
    }

    &__title {
        font-family: $font-display;
        font-size: 42px;
        font-weight: 700;
        color: $marrom-escuro;
        line-height: 1.15;

        em {
            font-style: italic;
            color: $caramelo;
        }
    }

    &__card {
        background-color: $branco;
        padding: 36px;
        height: 100%;
        border: 1px solid rgba($caramelo, 0.1);
        transition: all 0.4s ease;

        &:hover {
            box-shadow: 0 16px 48px rgba($marrom-escuro, 0.08);
            border-color: rgba($caramelo, 0.25);
        }

        &-header {
            display: flex;
            align-items: center;
            gap: 16px;
            margin-bottom: 20px;
        }

        &-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 52px;
            height: 52px;
            background-color: $creme;
            color: $caramelo;
            flex-shrink: 0;
        }

        &-title {
            font-family: $font-display;
            font-size: 24px;
            font-weight: 700;
            color: $marrom-escuro;
            margin: 0;
            line-height: 1.2;
        }

        &-badge {
            font-family: $font-body;
            font-size: 11px;
            letter-spacing: 2px;
            text-transform: uppercase;
            color: $caramelo;
            font-weight: 500;
        }

        &-address {
            font-size: 16px;
            line-height: 1.7;
            color: #6B5B50;
            margin-bottom: 24px;
            padding-left: 68px;
        }

        &-map {
            overflow: hidden;
            border: 1px solid rgba($caramelo, 0.1);

            iframe {
                display: block;
            }
        }
    }
}

@media (max-width: 991.98px) {
    .unidades {
        padding: 80px 0;

        &__title {
            font-size: 34px;
        }

        &__card {
            padding: 28px;

            &-address {
                padding-left: 0;
            }
        }
    }
}

@media (max-width: 575.98px) {
    .unidades {
        padding: 60px 0;

        &__title {
            font-size: 28px;
        }

        &__card {
            padding: 24px;

            &-map iframe {
                height: 220px;
            }
        }
    }
}
</style>
